import { AdditionalInfo } from '@gc-bridge/components/AdditionalInfo';
import { ManageCookiesButton } from '@gc-bridge/components/Button/ManageCookies';
import { ContentContainer, MainContainer } from '@gc-bridge/components/Container';
import { Footer } from '@gc-bridge/components/Footer';
import { GcBridgeBottom } from '@gc-bridge/components/GcBridgeBottom';
import { GcBridgeCover } from '@gc-bridge/components/GcBridgeCover';
import { Section } from '@gc-bridge/components/Section';
import { sections } from '@gc-bridge/constants';

export function Home() {
  return (
    <MainContainer>
      <GcBridgeCover />
      <AdditionalInfo />
      <ContentContainer>
        {sections.map((section) => (
          <Section key={section.title} section={section} />
        ))}
        <GcBridgeBottom />
        <Footer />
      </ContentContainer>
      <ManageCookiesButton />
    </MainContainer>
  );
}
